export default {
  operationCenter: {
    expressCompany: 'Carrier',
    prepaidFreight: 'Prepaid Shipping Fee',
    auto_43: 'Payment',
    auto_44: 'Update',
    auto_45: 'Details',
    auto_114: 'Cancel',
    auto_51: 'Review',
    auto_84: 'Replacement Item Inbound Shipment in Progress',
    auto_86: 'Pending Payment',
    auto_90: 'Pending Review',
    auto_93: 'Returned',
    auto_96: 'In Transit',
    auto_100: 'Confirm Receipt',
    auto_101: 'Pending Shipment',
    auto_102: 'Ship',
    auto_103: 'Shipped',
    auto_105: 'Completed',
    auto_106: 'Cancelled',
    auto_33: 'Send Verification Code',
    auto_34: 'Resend',
    auto_37: 'Once a Learning Tablet is marked as a demo device,',
    auto_38: 'Notice',
    auto_39: 'Confirm',
    auto_41: 'Purchase Order / Transfer Order Number',
    auto_42: 'Recipient Name',
    auto_32: 'Pending Selection Area',
    auto_21: 'Enter Code or Purchase Order Number',
    auto_22: 'Pending Selection',
    auto_23: 'Selected',
    auto_24: 'Activated',
    auto_25: 'Not Activated',
    auto_17: 'Master Franchisee Name',
    auto_18: 'Created By',
    auto_19: 'Shipping Warehouse',
    auto_20: 'Select Shipping Warehouse',
    auto_28: 'Shipping Address',
    auto_29: 'Enter Learning Center Address',
    auto_30: 'Notes',
    auto_31: 'Enter up to 200 characters',
    auto_11: 'Product Name',
    auto_13: 'Order Number',
    auto_14: 'Order Items',
    auto_15: 'Pending Shipment Quantity',
    auto_1: 'Purchase Order Number',
    auto_7: 'Recipient Phone Number',
    auto_8: 'State / City / ZIP Code',
    auto_10: 'Shipment Status',
    auto_107: 'Quantity',
    auto_108: 'Product',
    auto_109: 'John Doe',
    auto_110: '123 Main St, Los Angeles, CA 90012',
    auto_115: 'Outgoing Item',
    auto_116: 'Incoming Item',
    auto_117: 'Unit Price',
    auto_137: 'Inbound',
    auto_146: 'Outbound',
    auto_120: 'Headquarter Shipment',
    auto_122: 'Main Warehouse',
    auto_126: 'Enter Code',
    auto_128: 'Outgoing Item Shipment',
    auto_129: 'Incoming Item Shipment',
    auto_124: 'Back',
    auto_118: 'No Data',
    auto_119: 'Store Receipt',
    auto_134: 'Export Regional Shipment Records',
    auto_135: 'Cancellation Failed',
    auto_136: 'Export Sales Shipments',
    auto_132: 'Insurance Fee',
    auto_125: 'Update Failed',
    auto_131: 'JD Warehouse Shipping Configuration Export',
    textkwso: 'Product Details',
    texti5zt: 'Linked Orders',
    textjenf: 'Logistics Details',
    saleConsignmentDetailJdOutboundNo: 'JD Warehouse Outbound Number',
    saleConsignmentDetailAgentRecvWarehouse: 'Master Franchisee Receiving Warehouse',
    saleConsignmentDetailRemarkPh: 'Enter notes (up to 200 characters)',
    saleConsignmentTraceShippingDate: 'Shipping Date',
    saleConsignmentTraceExpressCompany: 'Carrier',
    saleConsignmentTraceWayBill: 'Tracking Number',
    saleConsignmentTraceLogisticsStatus: 'Logistics Status',
    saleConsignmentTraceShipNum: 'Shipped Quantity',
    headOfficeTransferModalTitle: 'Transfer',
    headOfficeTransferModalAgentIdLabel: 'Master Franchisee ID:',
    headOfficeTransferModalProductNameLabel: 'Product Name:',
    headOfficeTransferModalPONoLabel: 'Purchase Order / Transfer Order Number:',
    headOfficeTransferModalReceiverLabel: 'Recipient Name:',
    headOfficeTransferModalReceiverPhoneLabel: 'Recipient Phone Number:',
    headOfficeTransferModalProvinceCityLabel: 'State / City:',
    headOfficeTransferModalAddressLabel: 'Shipping Address:',
    headOfficeTransferModalOrderQtyLabel: 'Order Quantity:',
    headOfficeTransferModalShippedQtyLabel: 'Shipped Quantity:',
    headOfficeTransferModalExpressCompanyLabel: 'Carrier:',
    headOfficeTransferModalSelectExpressPlaceholder: 'Select Carrier',
    headOfficeTransferModalExpressNoLabel: 'Tracking Number:',
    headOfficeTransferModalFillExpressNo: 'Enter Tracking Number',
    headOfficeTransferModalPendingZone: 'Pending Selection',
    headOfficeTransferModalSelectedZone: 'Selected',
    headOfficeTransferModalFilterSnPurchasePlaceholder: 'Enter SN or Purchase Order Number',
  }
};
